import { clientEnv } from '@/shared/config/env';
import { requestJson } from '@/shared/request/http-client';

export interface PointsPwaInstallClaimResult {
  amountMinor: number;
  applied: boolean;
  balanceAfterMinor: number;
}

export const claimPwaInstallPoints = (authToken: string) =>
  requestJson<PointsPwaInstallClaimResult>('/v1/app/points/pwa-install-claim', {
    authToken,
    body: { siteId: clientEnv.siteId },
    method: 'POST',
  });
